import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StatusAlertComponent } from './status-alert.component';

@NgModule({
  declarations: [StatusAlertComponent],
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: '',
        component: StatusAlertComponent,
        children: [
          {
            path: '',
            loadChildren: () =>
              import('./status-alert-list-page/status-alert-list-page.module').then((m) => m.StatusAlertListPageModule),
          },
        ],
      },
    ]),
  ],
})
export class StatusAlertModule {}
